(function(){

  function snfPrice(h){ var m = window.SNF_PRICE || {}; return m[h] ? ('from ' + m[h]) : ''; }
  var PRESETS = [
    { key:'rake', name:'The Rake', tag:'Reckless Devotion', notes:['Cinnamon','Amber','Vanilla'], handle:'the-rake' },
    { key:'idealLover', name:'The Ideal Lover', tag:'Mirror of Dreams', notes:['Tuberose','Oud','Labdanum'], handle:'iconic-oil' },
    { key:'star', name:'The Star', tag:'Transcendent Distance', notes:['Grapefruit','Rose','Amber'], handle:'the-star' },
    { key:'natural', name:'The Natural', tag:'Playful Innocence', notes:['Neroli','Jasmine','Musk'], handle:'caramel-climax' },
    { key:'charmer', name:'The Charmer', tag:'Ego Flattery', notes:['Honey','Cocoa','Tonka'], handle:'nectar-nymph-oil' },
    { key:'charismatic', name:'The Charismatic', tag:'Radiant Presence', notes:['Rose','Violet','Cedar'], handle:'the-charismatic' },
    { key:'dandy', name:'The Dandy', tag:'Androgynous Allure', notes:['Rose','Leather','Frankincense'], handle:'the-dandy-2' },
    { key:'honeypot', name:'Honeypot', tag:'Golden Temptation', notes:['Bergamot','Amber','Patchouli'], handle:'honey-pot' },
    { key:'honeypotMatcha', name:'Honeypot Matcha', tag:'Serene Charge', notes:['Tea','Fig Leaf','Cedar'], handle:'velvet-mood-oil' },
    { key:'honeypotVanilla', name:'Honeypot Vanilla', tag:'Pure Indulgence', notes:['Vanilla','Tonka','Musk'], handle:'nectar-nymph' }
  ];

  function selectNotesViaUI(noteNames, cb){
    var clearBtn = document.getElementById('svClearBtn');
    if(clearBtn) clearBtn.click();
    var search = document.getElementById('svSearch');
    var i = 0;
    function next(){
      if(i >= noteNames.length){
        search.value = '';
        search.dispatchEvent(new Event('input'));
        if(cb) cb();
        return;
      }
      search.value = noteNames[i];
      search.dispatchEvent(new Event('input'));
      setTimeout(function(){
        var tile = document.querySelector('#svNoteGrid .sv-note[data-n="'+noteNames[i]+'"]');
        if(tile) tile.click();
        i++;
        next();
      }, 15);
    }
    next();
  }

  function injectStyle(){
    if(document.getElementById('svPresetStyle')) return;
    var s = document.createElement('style');
    s.id = 'svPresetStyle';
    s.textContent = '.sv-preset-row{display:grid;grid-template-columns:repeat(2,1fr);gap:8px;margin-bottom:14px;}'+
      '.sv-preset{border:1px solid rgba(255,255,255,.15);padding:10px 11px;cursor:pointer;text-align:left;background:#17140f;transition:.15s;}'+
      '.sv-preset:hover,.sv-preset.active{border-color:#a42325;background:#2a1210;}'+
      '.sv-preset-name{font-family:"Barlow Condensed",sans-serif;font-size:13px;text-transform:uppercase;letter-spacing:.02em;color:#f4efe6;}'+
      '.sv-preset-tag{font-size:10px;color:#a89f95;font-style:italic;margin-top:2px;}'+
      '.sv-preset-label{font-family:"Barlow Condensed",sans-serif;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#a42325;margin-bottom:8px;}'+
      '.sv-shop-match{margin-top:10px;padding:12px 14px;border:1px solid rgba(255,255,255,.15);display:none;align-items:center;justify-content:space-between;gap:10px;}'+
      '.sv-shop-match.show{display:flex;}'+
      '.sv-shop-match a{background:#a42325;color:#fff;text-decoration:none;padding:9px 16px;font-family:"Barlow Condensed",sans-serif;text-transform:uppercase;font-size:11px;letter-spacing:.06em;white-space:nowrap;}'+
      '.sv-shop-match a:hover{background:#780406;}'+
      '.sv-shop-match-text{font-size:12px;color:#c9c2ba;}';
    document.head.appendChild(s);
  }

  function buildPresetPanel(accordsEl){
    injectStyle();
    var wrap = document.createElement('div');
    var label = document.createElement('div');
    label.className = 'sv-preset-label';
    label.textContent = 'Match A Real Sniff London Scent';
    var row = document.createElement('div');
    row.className = 'sv-preset-row';

    var shopBox = document.createElement('div');
    shopBox.className = 'sv-shop-match';
    shopBox.innerHTML = '<div class="sv-shop-match-text"></div><a href="#" target="_blank">Shop Now</a>';

    PRESETS.forEach(function(p){
      var btn = document.createElement('div');
      btn.className = 'sv-preset';
      btn.innerHTML = '<div class="sv-preset-name">'+p.name+'</div><div class="sv-preset-tag">'+p.tag+'</div>';
      btn.addEventListener('click', function(){
        Array.prototype.forEach.call(row.children, function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        selectNotesViaUI(p.notes, function(){
          shopBox.querySelector('.sv-shop-match-text').innerHTML = 'This is <strong>'+p.name+'</strong>'+(snfPrice(p.handle)?' — '+snfPrice(p.handle):'');
          // RELATIVE, not absolute. An absolute https://sniff-london.com/... link
          // jumps out of the draft-theme preview to the LIVE store, so you can
          // never test the button on a draft. Keep it root-relative.
          shopBox.querySelector('a').href = '/products/'+p.handle;
          shopBox.classList.add('show');
        });
      });
      row.appendChild(btn);
    });

    wrap.appendChild(label);
    wrap.appendChild(row);
    accordsEl.parentNode.insertBefore(wrap, accordsEl);
    accordsEl.parentNode.insertBefore(shopBox, accordsEl.nextSibling);
    accordsEl.style.display = 'none';

    var clearBtn = document.getElementById('svClearBtn');
    if(clearBtn){
      clearBtn.addEventListener('click', function(){
        Array.prototype.forEach.call(row.children, function(b){ b.classList.remove('active'); });
        shopBox.classList.remove('show');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    var accordsEl = document.getElementById('svAccords');
    if(!accordsEl) return;
    buildPresetPanel(accordsEl);
  });
})();
